/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Fixed reason code for lecturer ID verification rejection.
 */
export type OralExamIdRejectionReason = (typeof OralExamIdRejectionReason)[keyof typeof OralExamIdRejectionReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamIdRejectionReason = {
  blurry: 'blurry',
  name_not_legible: 'name_not_legible',
  face_not_visible: 'face_not_visible',
  wrong_document: 'wrong_document',
  other: 'other',
} as const;
